// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"93f2c76b","127":"2d1aa241","453":"10721639","545":"c0e7b521","565":"fb7c0a2f","879":"499cbdb5"}[chunkId] + ".chunk.js";
};